module.exports = __webpack_public_path__ + "media/LACHSONG_NICOLE.f2964a82.mp3";